"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCompositeMonorailEvent = void 0;
function isCompositeMonorailEvent(monorailEvent) {
    return monorailEvent.schemaId !== undefined;
}
exports.isCompositeMonorailEvent = isCompositeMonorailEvent;
